import UserPage from 'flarum/components/UserPage';
import Page from 'flarum/components/Page';
import Stream from 'flarum/common/utils/Stream';
import Button from 'flarum/common/components/Button';
import TagSelectionModal from 'flarum/tags/common/components/TagSelectionModal';
import app from 'flarum/forum/app';

export default class JeepytaFilesSettingsPage extends UserPage {

  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    // State management for files
    this.files = [];
    this.isLoading = true;
    this.prompts = {};


    // Fetch files from the API
    app.store.find('files').then((files) => {
      this.files = files;
      this.isLoading = false;
      m.redraw(); // Trigger UI update
    });

    // Load JSON settings from forum attributes
    const settings = app.forum.attribute('blomstra-support-ai.persona') || {};
    // Get all tags
    const tags = app.store.all('tags');

    // Create a stream for each tag.slug
    this.prompts = {};
    tags.forEach((tag) => {
      const slug = tag.slug();
      this.prompts[slug] = Stream(settings[slug]?.prompt || '');
    });
  }

  content() {

    // setTimeout(() => {
    //   if (!app.session) {
    //     console.log('app.session is still undefined.');
    //     return;
    //   }
      const tags = app.store.all('tags');
      const user = app.session.user;
      // console.log(user.isAdmin());
      // console.log(user.attribute('canAccessJeepyta'));
      if (user.isAdmin() || user.attribute('canAccessJeepyta'))
      {
        return (
          <div className="SettingsPage">
            <div className="container">


              <div className="Form">
                <div className="JeepytaFilesSettingsPage">
                  <h2>JeepyTA - prompts</h2>
                  <p>Adjust your JeepyTA prompts</p>

                </div>

                {tags.map((tag) => (
                  <div className="JeepytaSettingsBlock">
                    <h3>{tag.name()}</h3>
                    <textarea
                      rows="10"
                      style={{ width: '80%' }}
                      value={this.prompts[tag.slug()]()}
                      oninput={(e) => this.prompts[tag.slug()](e.target.value)}
                    />
                  </div>
                ))}
                <Button className="Button Button--primary" onclick={this.save.bind(this)}>
                  Save
                </Button>

              </div>

              <div className="Form">
                <div className="JeepytaFilesSettingsPage">
                  <h2>JeepyTA - files</h2>
                  <p>Adjust your JeepyTA files below</p>
                  <h3>List of files</h3>
                </div>
                {this.isLoading
                  ? m('div', 'Loading files...')
                  : this.files.map((file) => this.renderFile(file, "manage"))}
              </div>
            </div>
          </div>
        );
      }
      else
      {
        return (
          <div className="SettingsPage">
            <div className="container">
              <div className="Form">
                <div className="JeepytaFilesSettingsPage">
                  <h2>JeepyTA - files</h2>
                </div>
                {this.isLoading
                  ? m('div', 'Loading files...')
                  : this.files
                    .filter((file) => file.hidden() === false)
                    .map((file) => this.renderFile(file, "view"))}
              </div>
            </div>
          </div>
        );
      }
    // }, 0);

  }
  save() {
    const newSettings = {};

    Object.keys(this.prompts).forEach((key) => {
      newSettings[key] = {
        prompt: this.prompts[key](),
      };
    });

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/jeepyta-settings',
        body: { 'blomstra-support-ai.persona': JSON.stringify(newSettings) },
      })
      .then((response) => {
        if (response.saved) {
          app.alerts.show({ type: 'success' }, 'Settings saved');
        } else {
          app.alerts.show({ type: 'error' }, 'Failed to save settings');
        }
      })
      .catch((error) => {
        if (error.response && error.response.error) {
          app.alerts.show({ type: 'error' }, error.response.error);
        } else {
          app.alerts.show({ type: 'error' }, 'Error while saving settings');
        }
      });
  }
  renderFile(file, permission) {
    const associatedTags = file.data.attributes.associatedTags || [];
    const tagModels = associatedTags
      .map((tagId) => app.store.getById('tags', tagId))
      .filter(Boolean);

    // console.log(file.baseName(), " ", file.attribute('hasEmbeddings'));

    if(permission === "manage") {

      return m('div', {className: 'FileItem'}, [
        m('label', [
          '',
          m('a', {className: 'FileLink', href: file.url(), download: file.baseName()}, file.baseName()), // File name as a downloadable link
          file.attribute('hasEmbeddings') !== false
            ? m('i', {
                className: 'icon fas fa-circle green-circle',
            }) // Add Font Awesome circle if attribute is not null
            : m('i', {
              className: 'icon fas fa-circle gray-circle',
            }), // Otherwise, add nothing
          file.attribute('hidden') == true
            ? m('i', {className: 'icon fas fa-eye-slash private-icon', 'aria-label': 'Private File', 'data-original-title': 'Private File'}) // Lock icon for private
            : m('i', {className: 'icon fas fa-eye public-icon', 'aria-label': 'Public File', 'data-original-title': 'Public File'}) // Globe icon for public
        ]),

        // Render selected tags as badges
        m(
          'div',
          {className: 'TagList'},
          tagModels.length
            ? tagModels
              .sort((a, b) => a.id() - b.id())
              .map((tag) =>
              m('span', {className: 'TagBadge'}, tag.name())
            )
            : m('span', {className: 'NoTags'}, 'No tags selected')
        ),

        // Button to open "Choose Tags" modal
        Button.component(
          {
            className: 'Button Button--primary',
            onclick: () => {
              app.modal.show(TagSelectionModal, {
                selectedTags: tagModels,
                onsubmit: (selectedTags) => {
                  const tagIds = selectedTags.map((tag) => tag.id());

                  // Save the selected tags for this file
                  app.request({
                    method: 'POST',
                    url: app.forum.attribute('apiUrl') + `/files/${file.id()}/tags`,
                    body: {tag_ids: tagIds}, // Replace 'tag_ids' with the correct parameter name
                  })
                    .then(() => {
                      app.alerts.show(
                        {type: 'success'},
                        'Tags updated successfully'
                      );
                      file.pushAttributes({associatedTags: tagIds}); // Update local model
                    })
                    .catch(() => {
                      app.alerts.show(
                        {type: 'error'},
                        'Failed to update tags'
                      );
                    });
                },
              });
            },
          },
          'Choose Tags'
        ),
      ]);
    }
    else
    {
      return m('div', {className: 'FileItem'}, [
        m('label', [
          '',
          file.hidden() === false // only public files displayed
          ? m('a', {className: 'FileLink', href: file.url(), download: file.baseName()}, file.baseName())
            : null
        ]),
        // Render selected tags as badges
        m(
          'div',
          {className: 'TagList'},
          tagModels.length
            ? tagModels
              .sort((a, b) => a.id() - b.id())
              .map((tag) =>
              m('span', {className: 'TagBadge'}, tag.name())
            )
            : m('span', {className: 'NoTags'}, 'No tags selected')
        ),

        // Button to open "Choose Tags" modal
        // Button.component(
        //   {
        //     className: 'Button Button--primary',
        //     onclick: () => {
        //       app.modal.show(TagSelectionModal, {
        //         selectedTags: tagModels,
        //         onsubmit: (selectedTags) => {
        //           const tagIds = selectedTags.map((tag) => tag.id());
        //
        //           // Save the selected tags for this file
        //           app.request({
        //             method: 'POST',
        //             url: app.forum.attribute('apiUrl') + `/files/${file.id()}/tags`,
        //             body: {tag_ids: tagIds}, // Replace 'tag_ids' with the correct parameter name
        //           })
        //             .then(() => {
        //               app.alerts.show(
        //                 {type: 'success'},
        //                 'Tags updated successfully'
        //               );
        //               file.pushAttributes({associatedTags: tagIds}); // Update local model
        //             })
        //             .catch(() => {
        //               app.alerts.show(
        //                 {type: 'error'},
        //                 'Failed to update tags'
        //               );
        //             });
        //         },
        //       });
        //     },
        //   },
        //   'Choose Tags'
        // )
        ,
      ]);
    }
  }

}
